"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/pointer/EventType
 */

/**
 * Constants for event names.
 * @enum {string}
 */
var _default = {
  POINTERMOVE: 'pointermove',
  POINTERDOWN: 'pointerdown',
  POINTERUP: 'pointerup',
  POINTEROVER: 'pointerover',
  POINTEROUT: 'pointerout',
  POINTERENTER: 'pointerenter',
  POINTERLEAVE: 'pointerleave',
  POINTERCANCEL: 'pointercancel'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7ZUFJZTtFQUNiQSxXQUFXLEVBQUUsYUFEQTtFQUViQyxXQUFXLEVBQUUsYUFGQTtFQUdiQyxTQUFTLEVBQUUsV0FIRTtFQUliQyxXQUFXLEVBQUUsYUFKQTtFQUtiQyxVQUFVLEVBQUUsWUFMQztFQU1iQyxZQUFZLEVBQUUsY0FORDtFQU9iQyxZQUFZLEVBQUUsY0FQRDtFQVFiQyxhQUFhLEVBQUU7QUFSRixDIiwibmFtZXMiOlsiUE9JTlRFUk1PVkUiLCJQT0lOVEVSRE9XTiIsIlBPSU5URVJVUCIsIlBPSU5URVJPVkVSIiwiUE9JTlRFUk9VVCIsIlBPSU5URVJFTlRFUiIsIlBPSU5URVJMRUFWRSIsIlBPSU5URVJDQU5DRUwiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3BvaW50ZXIvRXZlbnRUeXBlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19